import axios, { type AxiosError } from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE ?? "/api",
  withCredentials: true,
});

let accessToken: string | null = null;

export const setAccessToken = (t: string | null) => {
  accessToken = t;
};

export const getAccessToken = (): string | null => accessToken;

api.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

let refreshing: Promise<string | null> | null = null;

api.interceptors.response.use(undefined, async (error: AxiosError) => {
  const original = error.config as (typeof error.config & { _retried?: boolean }) | undefined;
  // NUNCA re-tentar refresh quando a request que falhou É o próprio
  // /auth/refresh — senão cada 401 dispara outro refresh (loop infinito de
  // 401 no console e "Verificando sessão…" eterno com cookie expirado).
  const isRefreshCall = (original?.url ?? "").includes("/auth/refresh");
  if (error.response?.status === 401 && original && !original._retried && !isRefreshCall) {
    original._retried = true;
    if (!refreshing) {
      refreshing = (async () => {
        try {
          const res = await api.post<{ accessToken: string }>("/auth/refresh", {});
          accessToken = res.data.accessToken ?? null;
          return accessToken;
        } catch {
          accessToken = null;
          // Sessão morta: remove a flag "permanecer conectado" para o próximo
          // bootstrap não insistir. (Redirect/limpeza global: authWatchdog do DS.)
          try { localStorage.removeItem("safrater_stay"); } catch { /* */ }
          return null;
        } finally {
          refreshing = null;
        }
      })();
    }
    const fresh = await refreshing;
    if (fresh && original) {
      if (!original.headers) {
        original.headers = {} as typeof original.headers;
      }
      (original.headers as Record<string, string>).Authorization = `Bearer ${fresh}`;
      return api(original);
    }
  }
  return Promise.reject(error);
});

export { api };
